<template>
    <div class="ah-project-table-profit">
        <el-tooltip v-if="isCurrHidden" class="item" effect="dark" content="進行中專案，點擊顯示毛利" placement="top">
            <div v-if="isCurrHidden" class="hide-btn" @click="onClick"><i class="el-icon-more" /></div>
        </el-tooltip>
        <div v-if="!isCurrHidden">
            <div class="sub-label percentage">{{ percentage }}%</div>
            <Money round :v="profit" :class="{ negative: profit < 0 }" showPositivePlus />
            <div class="cny">TWD</div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        profit: {
            type: Number,
            default: 0,
        },
        percentage: {
            type: String,
            default: '',
        },
        isHidden: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isCurrHidden: false,
        };
    },
    mounted() {
        this.isCurrHidden = this.isHidden;
    },
    methods: {
        onClick(e) {
            this.isCurrHidden = false;
            e.preventDefault();
            e.stopPropagation();
        },
    },
};
</script>
<style lang="scss">
.ah-project-table-profit {
    font-size: 9pt;

    .hide-btn {
        position: relative;
        left: 8px;
        display: inline-block;
        padding: 2px 8px;
        border-radius: 4px;
        background-color: transparent;
        cursor: pointer;

        &:hover {
            background-color: rgba(0, 0, 0, 0.04);
        }

        i {
            opacity: 0.2;
            font-size: 8pt;
        }
    }
    .sub-label.percentage {
        color: #222;
        font-weight: bold;
        font-size: 9pt;
    }
    .money {
        font-weight: normal;
        line-height: 100%;

        &.negative {
            color: rgb(222, 66, 66);
        }
        &.positive {
            color: #58c406;
        }
    }
    .cny {
        color: #aaa;
        font-size: 8pt !important;
        margin: -3px 0;
    }
}
</style>
